import { max } from "lodash";
import { useMemo } from "react";

import { useEltSyncSnapshotStateQuery } from "@/apollo/types";
import { FormatRelativeTime } from "@/components/elements/FormatRelativeTime";
import { FormatTime } from "@/components/elements/FormatTime";
import Tooltip from "@/components/elements/Tooltip";

export function LastSuccessfulSyncCell(props: { syncId: string }) {
  const { data } = useEltSyncSnapshotStateQuery({
    variables: {
      syncId: props.syncId,
    },
  });

  const lastSuccessfulSync = useMemo(() => {
    if (!data?.eltSyncSnapshotState) {
      return null;
    }

    return max(
      data.eltSyncSnapshotState.sourceStreams
        .map((stream) => stream.latestSync)
        .filter((job) => job?.status === "COMPLETED")
        .map((job) => job?.finishedAt),
    );
  }, [data]);

  return (
    <div className="text-muted-foreground">
      {lastSuccessfulSync ? (
        <Tooltip
          content={<FormatTime date={lastSuccessfulSync} format="LLL" />}
        >
          <div className="truncate">
            <FormatRelativeTime date={lastSuccessfulSync} />
          </div>
        </Tooltip>
      ) : (
        "-"
      )}
    </div>
  );
}
